import { render, staticRenderFns } from "./vanOnkyOffice.vue?vue&type=template&id=4baca648"
import script from "./vanOnkyOffice.vue?vue&type=script&lang=js"
export * from "./vanOnkyOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports